import React from "react";
import ProjectCard from "./ProjectCards";
import { projects } from "../../data/projects";

function Projects() {
  return (
    <main className="page page--interior">
      <header className="page-header">
        <p className="section-kicker">Projects</p>
        <h1 className="section-title">Selected projects</h1>
        <p className="page-lead">
          A short shelf. Each of these started as a question I wanted to sit with, not a line
          I needed to add.
        </p>
      </header>

      <div className="case-list">
        {projects.map((project) => (
          <ProjectCard
            key={project.id}
            imgPath={project.imgPath}
            title={project.title}
            context={project.context}
            description={project.description}
            ghLink={project.ghLink}
            demoLink={project.demoLink}
          />
        ))}
      </div>
    </main>
  );
}

export default Projects;
